import React from 'react';
import { Route, Routes } from 'react-router-dom';
import EventLogClinicDetail from './EventLogClinicDetail';
import EventLogClinics from './EventLogClinics';

const EventLogs: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<EventLogClinics />} />
      <Route path="/:clinicId" element={<EventLogClinicDetail />} />
    </Routes>
  );
};

export default EventLogs;
